// Coloured Icon
// This file is automatically generated from SVG file
// Do not modify manually
"use client";

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
import styled from "styled-components";
var SVG = function SVG(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    width: props.size || "2.5em",
    height: props.size || "2.5em",
    "aria-hidden": true,
    className: props.className
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB932",
    d: "M12 2 1 22h22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M11 9v7h2V9zm0 8.25v2h2v-2z"
  }));
};
var WarningFilledIcon = styled(SVG).withConfig({
  displayName: "WarningFilledIcon",
  componentId: "sc-128ktdd-0"
})(["flex-shrink:0;"]);
export default WarningFilledIcon;